import React, { Component } from 'react'
import { Field, reduxForm } from 'redux-form'
import { connect } from 'react-redux'

import Input from 'components/atoms/inputs/simpliest_input'
import { completeEditServiceStep, selectEditServiceStep, uncheckEditServiceStep } from 'actions/shared'
import { updateService, fetchJobService } from 'actions/artists'
import { EDIT_SERVICE_VIEWS } from 'constants/index'
import Button from 'components/atoms/buttons/solid'
import { capitalizeString } from 'helpers/index'

class EditServiceName extends Component{
    constructor(props){
        super(props)
        this.validateName = this.validateName.bind(this)
    }

    validateName(name){
        if(!name){
            this.props.uncheckEditServiceStep(EDIT_SERVICE_VIEWS.name)
            return 'Debes definir un nombre para tu servicio'
        }
        else
            this.props.completeEditServiceStep(EDIT_SERVICE_VIEWS.name)
    }

    onSubmit(values){
        const change = { title : capitalizeString(values.name) }
        this.props.updateService(change, this.props.job_service_selected.id, () => {
            this.props.completeEditServiceStep(EDIT_SERVICE_VIEWS.name)
            const service_id = window.location.href.split('/').pop()
            this.props.fetchJobService(service_id)
        })
    }

    render(){
        const { handleSubmit } = this.props
        return (
            <>
                <h2 className='text-secondary'>Título del servicio</h2>
                <p>Ingresa el título de tu servicio</p>
                <form onSubmit={handleSubmit(this.onSubmit.bind(this))} className='p-2'>
                    <Field
                        name="name"
                        type="text"
                        placeholder="Agrega un título"
                        validate={this.validateName}
                        component={Input}
                    />
                    <div className='my-4 d-flex justify-content-center'>
                        <Button 
                            type='submit' 
                            color='primary' 
                            text='Guardar'
                        />
                    </div>
                </form>
            </>
        )
    }
}

function mapStateToProps({ artist }){
    const { job_service_selected } = artist
    const initialValues = {
        'name' : job_service_selected.title
    }
    return { job_service_selected, initialValues }
}

EditServiceName = reduxForm({
    form: 'editServiceWizard', // <------ same form name
    destroyOnUnmount: false, // <------ preserve form data
    forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
    enableReinitialize: true
  })(EditServiceName)
  
  EditServiceName = connect(
    mapStateToProps,
    { completeEditServiceStep, selectEditServiceStep, uncheckEditServiceStep, updateService, fetchJobService }
  )(EditServiceName)
  
  export default EditServiceName